import { Component, OnInit, AfterViewInit } from "@angular/core";
import { ReportService } from "../report.service";
//Import Custom Services Here
import { SchoolService } from "../../../shared/services/school.service";
import { AcademyService } from "../report-services/academy.service";
import { GradeLevelService } from "../report-services/grade-level.service";
import { GroupService } from "../report-services/group.service";
import { HomeroomService } from "../report-services/homeroom.service";
import { TeacherPersonService } from "../report-services/teacher-person.service";
import { SemesterService } from "../report-services/semester.service";
import { DayService } from "../report-services/day.service";
import { SchoolselectorService } from "../../schoolselector/schoolselectorservice.service";
import { DialogService } from "primeng/dynamicdialog";
import { MergeToGroupDialogComponent } from "../merge-to-group-dialog/merge-to-group-dialog.component";
import { MergeToGroupRequest } from "../report-services/merge-to-group-request";

@Component({
	templateUrl: "./photosby.component.html",
})
export class PhotosbyComponent implements OnInit {
	constructor(
		private selectService: SchoolselectorService,
		private reportService: ReportService,
		//Insert Custom Services Here
		private academyService: AcademyService,
		private schoolService: SchoolService,
		private gradeLevelService: GradeLevelService,
		private groupService: GroupService,
		private homeroomService: HomeroomService,
		private teacherPersonService: TeacherPersonService,
		private semesterService: SemesterService,
		private dayService: DayService,
		private dialogService: DialogService
	) {}
	report = {
		//Insert Custom Parameters Here
		SchoolID: 0,
		ByTypeID: "Academy",
		ColumnsID: "3",
		AcademyID: 0,
		PageByACADID: "Yes",
		W_ID: "Yes",
		W_HPhoneID: "Yes",
		W_HRoomID: "Yes",
		W_DOBID: "Yes",
		W_NameID: "Yes",

		GradeLevelID: 0,
		GroupID: 0,
		PageByGroup: "Yes",
		HomeRoomID: 0,
		PageByHR: "Yes",
		TeacherPersonID: 0,
		SemesterID: 0,
		DayID: 0,
		BySection: "Yes",
		ORDERBY: "Academy",
	};
	//Insert Custom Lists Here
	schoolList: any = [];
	AcademyList: any = [];
	GradeLevelList: any = [];
	GroupList: any = [];
	HomeroomList: any = [];
	TeacherPersonList: any = [];
	SemesterList: any = [];
	DayList: any = [];

	user: any;
	errorMessage: any = "";
	isProcessing: any = false;

	ByTypeList = [
		//Insert Custom List Items Here
		{
			ByTypeID: "Academy",
			ByTypeName: "Academy",
		},
		{
			ByTypeID: "Grade",
			ByTypeName: "Grade",
		},
		{
			ByTypeID: "Group",
			ByTypeName: "Group",
		},
		{
			ByTypeID: "Homeroom",
			ByTypeName: "Homeroom",
		},
		{
			ByTypeID: "Instructor",
			ByTypeName: "Instructor",
		},
		{
			ByTypeID: "School",
			ByTypeName: "School",
		},
	];

	ColumnsList = [
		//Insert Custom List Items Here
		{
			ColumnsID: "3",
			ColumnsName: "3",
		},
		{
			ColumnsID: "4",
			ColumnsName: "4",
		},
	];

	YNList = [
		//Insert Custom List Items Here
		{
			ID: "Yes",
			Desc: "Yes",
		},
		{
			ID: "No",
			Desc: "No",
		},
	];

	ORDERBYList = [
		//Insert Custom List Items Here
		{
			ID: "Academy",
			Desc: "Academy",
		},
		{
			ID: "Grade",
			Desc: "Grade",
		},
		{
			ID: "Homeroom",
			Desc: "Homeroom",
		},
		{
			ID: "Name",
			Desc: "Name",
		},
	];

	OutputTypeID: any = 1;
	OutputTypeList = [
		{
			ID: 1,
			Desc: ".PDF",
		},
		// {
		//     ID: 2,
		//     Desc: ".Doc (Word Document)" //Doesn't seem to work
		// },
		// {
		//     ID: 3,
		//     Desc: ".xls (Excel file)" //Ending Support for xls, just use CSV
		// },
		{
			ID: 4,
			Desc: ".CSV (Excel file)",
		},
		{
			ID: 5,
			Desc: ".RTF (Rich Text File)",
		},
		// {
		//     ID: 6,
		//     Desc: ".XML" //Doesn't seem to work
		// },
		{
			ID: 7,
			Desc: ".HTM (Web Page)",
		},
		// {
		//     ID: 8,
		//     Desc: ".rpt" //Doesn't seem to work
		// },
		// {
		//     ID: 9,
		//     Desc: ".grp" //Doesn't seem to work
		// }
	];

	subscription: any;

	ngOnInit() {
		//Insert Custom Init Methods Here
		// this.loadSchoolist()
		//this.loadAcademyList()

		this.subscription = this.selectService.onSchoolChanged().subscribe((school) => {
			// this.SchoolID = school.SchoolID;
			this.onSchoolChange(school.SchoolID);
		});
	}

	ngOnDestroy() {
		this.subscription.unsubscribe();
	}

	onSchoolChange(value) {
		this.report.SchoolID = value;
		this.loadAcademyList();
		this.loadGradeLevelList();
		this.loadGroupList();
		this.loadHomeroomList();
		this.loadTeacherPersonList();
		this.loadSemesterList();
		this.loadDayList();
	}

	private loadSchoolist() {
		var result = this.schoolService.GetSchoolsForUserReport(214);
		result.subscribe(
			(response) => {
				this.schoolList = response;

				if (this.schoolList.length > 1) {
					this.schoolList.unshift({
						SchoolID: 0,
						SchoolName: "All Schools",
					});
				} else {
					this.onSchoolChange(this.schoolList[0].SchoolID);
				}
			},
			(error) => {}
		);
	}

	private loadAcademyList() {
		this.report.AcademyID = 0;
		var result = this.academyService.loadAcademyList("", this.report.SchoolID);
		result.subscribe(
			(response) => {
				this.AcademyList = response;

				if (this.AcademyList.length > 1) {
					// this.AcademyList.unshift({
					//     AcademyId: 0,
					//     AcademyDesc: "All Academys"
					// })
					this.report.AcademyID = this.AcademyList[0].AcademyId;
				} else {
					this.report.AcademyID = this.AcademyList[0].AcademyId;
				}
			},
			(error) => {}
		);
	}

	private loadGradeLevelList() {
		this.report.GradeLevelID = 0;
		var result = this.gradeLevelService.loadGradeLevelList("", this.report.SchoolID);
		result.subscribe(
			(response) => {
				this.GradeLevelList = response;

				this.report.GradeLevelID = this.GradeLevelList[0].GradeLevelID;
			},
			(error) => {}
		);
	}

	private loadGroupList() {
		this.report.GroupID = 0;
		var result = this.groupService.loadGroupList("", this.report.SchoolID);
		result.subscribe(
			(response) => {
				this.GroupList = response;

				this.report.GroupID = this.GroupList[0].GroupID;
			},
			(error) => {}
		);
	}

	private loadHomeroomList() {
		this.report.HomeRoomID = 0;
		var result = this.homeroomService.loadHomeroomList("", this.report.SchoolID);
		result.subscribe(
			(response) => {
				this.HomeroomList = response;

				this.report.HomeRoomID = this.HomeroomList[0].HomeroomId;
			},
			(error) => {}
		);
	}

	private loadTeacherPersonList() {
		this.report.TeacherPersonID = 0;
		var result = this.teacherPersonService.InstructorPersonNotAllGetList("", this.report.SchoolID);
		result.subscribe(
			(response) => {
				this.TeacherPersonList = response;

				this.report.TeacherPersonID = this.TeacherPersonList[0].Teacher_PersonID;
			},
			(error) => {}
		);
	}

	private loadSemesterList() {
		this.report.SemesterID = 0;
		var result = this.semesterService.loadSemesterList(this.report.SchoolID);
		result.subscribe(
			(response) => {
				this.SemesterList = response;

				this.report.SemesterID = this.SemesterList[0].SemesterID;
			},
			(error) => {}
		);
	}

	private loadDayList() {
		this.report.DayID = 0;
		var result = this.dayService.loadDayList("", this.report.SchoolID);
		result.subscribe(
			(response) => {
				this.DayList = response;

				this.report.DayID = this.DayList[0].DayID;
			},
			(error) => {}
		);
	}

	Print() {
		var component = this;
		this.errorMessage = "";

		//Insert Custom Error Checks Here
		if (!this.report.SchoolID) {
			this.errorMessage = "Select the School";
			return;
		}

		// if (!this.report.ByTypeID) {
		// 	this.errorMessage = "Select the ByType"
		// 	return;
		// }

		// if (!this.report.ColumnsID) {
		// 	this.errorMessage = "Select the Columns"
		// 	return;
		// }

		// if (!this.report.AcademyID) {
		// 	this.errorMessage = "Select the Academy"
		// 	return;
		// }

		// if (!this.report.PageByACADID) {
		// 	this.errorMessage = "Select the PageByACAD"
		// 	return;
		// }

		// if (!this.report.W_ID) {
		// 	this.errorMessage = "Select the W_"
		// 	return;
		// }

		// if (!this.report.W_HPhoneID) {
		// 	this.errorMessage = "Select the W_HPhone"
		// 	return;
		// }

		// if (!this.report.W_HRoomID) {
		// 	this.errorMessage = "Select the W_HRoom"
		// 	return;
		// }

		// if (!this.report.W_DOBID) {
		// 	this.errorMessage = "Select the W_DOB"
		// 	return;
		// }

		// if (!this.report.W_NameID) {
		// 	this.errorMessage = "Select the W_Name"
		// 	return;
		// }

		var reportID = 214;

		// Select Report Type
		if (this.report.ByTypeID == "Academy") {
			if (this.report.ColumnsID == "3") {
				reportID = 214;
			} else {
				reportID = 215;
			}
		} else if (this.report.ByTypeID == "Grade") {
			if (this.report.ColumnsID == "3") {
				reportID = 210;
			} else {
				reportID = 211;
			}
		} else if (this.report.ByTypeID == "Group") {
			if (this.report.ColumnsID == "3") {
				reportID = 216;
			} else {
				reportID = 217;
			}
		} else if (this.report.ByTypeID == "Homeroom") {
			if (this.report.ColumnsID == "3") {
				reportID = 212;
			} else {
				reportID = 213;
			}
		} else if (this.report.ByTypeID == "Instructor") {
			if (this.report.ColumnsID == "3") {
				reportID = 220;
			} else {
				reportID = 221;
			}
		} else if (this.report.ByTypeID == "School") {
			if (this.report.ColumnsID == "3") {
				reportID = 218;
			} else {
				reportID = 219;
			}
		}

		var strParam = this.GetStrParam(reportID);
		this.isProcessing = true;

		var result = this.reportService.Print(reportID, strParam, this.report.SchoolID, this.OutputTypeID);

		result.subscribe(
			(response: any) => {
				component.isProcessing = false;
				window.open(response);
			},
			(error) => {
				component.errorMessage = error;
				component.isProcessing = false;
			}
		);
	}

	GetStrParam(reportID): string {
		var strParam: string = "";

		//Insert Custom Parameters Here

		//Parameter 1: SchoolID
		strParam += this.report.SchoolID + "|SchoolID";

		// //Parameter 2: ByType
		// strParam += "," + this.report.ByTypeID + "|ByType";

		// //Parameter 3: Columns
		// strParam += "," + this.report.ColumnsID + "|Columns";

		//Academy
		if (reportID == 214 || reportID == 215) {
			//Parameter 4: AcademyID
			strParam += "," + this.report.AcademyID + "|AcademyID";

			//Parameter 5: PageByACAD
			strParam += "," + this.report.PageByACADID + "|PageByACAD";
		}

		//Grade
		else if (reportID == 210 || reportID == 211) {
			strParam += "," + this.report.GradeLevelID + "|GradeLevelID";
		}

		//Group
		else if (reportID == 216 || reportID == 217) {
			strParam += "," + this.report.GroupID + "|GroupID";

			strParam += "," + this.report.PageByGroup + "|PageByGroup";
		}

		//Homeroom
		else if (reportID == 212 || reportID == 213) {
			strParam += "," + this.report.HomeRoomID + "|HomeRoomID";

			strParam += "," + this.report.PageByHR + "|PageByHR";
		}

		//Instructor
		else if (reportID == 220 || reportID == 221) {
			strParam += "," + this.report.TeacherPersonID + "|TeacherPersonID";

			strParam += "," + this.report.SemesterID + "|SemesterID";

			strParam += "," + this.report.DayID + "|DayID";

			strParam += "," + this.report.BySection + "|BySection";
		}

		//School
		else if (reportID == 218 || reportID == 219) {
			strParam += "," + this.report.ORDERBY + "|ORDERBY";
		}

		//Generic params
		//W_ID
		strParam += "," + this.report.W_ID + "|W_ID";

		//W_HPhone
		strParam += "," + this.report.W_HPhoneID + "|W_HPhone";

		//W_HRoom
		strParam += "," + this.report.W_HRoomID + "|W_HRoom";

		//W_DOB
		strParam += "," + this.report.W_DOBID + "|W_DOB";

		//W_Name
		strParam += "," + this.report.W_NameID + "|W_Name";

		return strParam;
	}

	MergeToGroup() {
		this.errorMessage = "";

		this.isProcessing = true;

		var reportID = 214;

		// Select Report Type
		if (this.report.ByTypeID == "Academy") {
			if (this.report.ColumnsID == "3") {
				reportID = 214;
			} else {
				reportID = 215;
			}
		} else if (this.report.ByTypeID == "Grade") {
			if (this.report.ColumnsID == "3") {
				reportID = 210;
			} else {
				reportID = 211;
			}
		} else if (this.report.ByTypeID == "Group") {
			if (this.report.ColumnsID == "3") {
				reportID = 216;
			} else {
				reportID = 217;
			}
		} else if (this.report.ByTypeID == "Homeroom") {
			if (this.report.ColumnsID == "3") {
				reportID = 212;
			} else {
				reportID = 213;
			}
		} else if (this.report.ByTypeID == "Instructor") {
			if (this.report.ColumnsID == "3") {
				reportID = 220;
			} else {
				reportID = 221;
			}
		} else if (this.report.ByTypeID == "School") {
			if (this.report.ColumnsID == "3") {
				reportID = 218;
			} else {
				reportID = 219;
			}
		}

		var strParam = this.GetStrParam(reportID);

		var parms: MergeToGroupRequest = {
			ReportID: reportID,
			SchoolID: this.report.SchoolID,
			strParms: strParam,
		};

		var result = this.reportService.MergeToGroupSelectInfo(parms);
		result.subscribe(
			(response: any) => {
				if (response.length > 0) {
					var ref = this.dialogService.open(MergeToGroupDialogComponent, {
						header: "Merge to Group",
						width: "fit-content",
						data: {
							//INSERT Custom Data here
							lstPerson: response,
							SchoolID: this.report.SchoolID,
						},
					});
					ref.onClose.subscribe((response) => {
						if (response == 1) {
						}
					});
				} else {
					this.errorMessage = "No Data available";
				}

				this.isProcessing = false;
			},
			(error) => {
				this.errorMessage = error;
				this.isProcessing = false;
			}
		);
	}
}
